// src/services/notificationService.js
import { toast } from 'react-toastify'
import DOMPurify from 'dompurify'

const hasHtml = (s) => typeof s === 'string' && /<\/?[a-z][\s\S]*>/i.test(s)
// Convert possibly-HTML to plain text
const toPlainText = (s) =>
  typeof s === 'string'
    ? DOMPurify.sanitize(s, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }).trim()
    : s

function extractMessagesFromData(data) {
  const out = []
  if (data == null) return out

  // If backend returned a whole HTML page (e.g., Django 404/500)
  if (typeof data === 'string') {
    out.push(hasHtml(data) ? toPlainText(data) : data)
    return out
  }

  // If backend returned a top-level array of errors
  if (Array.isArray(data)) {
    data.forEach((v) => out.push(String(v)))
    return out
  }

  // Object – collect common fields first
  if (typeof data === 'object') {
    const common = ['message', 'detail', 'error', 'errors', 'non_field_errors']
    common.forEach((k) => {
      const v = data[k]
      if (Array.isArray(v)) v.forEach((m) => out.push(String(m)))
      else if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean')
        out.push(String(v))
    })

    // Then flatten the rest (including nested objects)
    Object.entries(data).forEach(([k, v]) => {
      if (common.includes(k)) return
      if (Array.isArray(v)) v.forEach((m) => out.push(`${k}: ${String(m)}`))
      else if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean')
        out.push(`${k}: ${String(v)}`)
      else if (v && typeof v === 'object') {
        Object.values(v).forEach((inner) => {
          if (Array.isArray(inner)) inner.forEach((m) => out.push(`${k}: ${String(m)}`))
          else if (typeof inner === 'string') out.push(`${k}: ${inner}`)
        })
      }
    })
  }

  return out
}

export const showErrorNotification = (error) => {
  let messages = []

  if (error?.response) {
    // Axios got a response from the server
    messages = extractMessagesFromData(error.response.data)
    if (!messages.length) {
      const { status, statusText } = error.response
      if (status || statusText) messages = [`Error ${status || ''} ${statusText || ''}`.trim()]
    }
  } else if (error?.request && !error?.response) {
    // Network problem / server down
    messages = ['El servidor no está respondiendo. Por favor, verifique su conexión a internet o intente más tarde.']
  } else if (error?.code === 'ECONNABORTED') {
    messages = ['La solicitud tomó demasiado tiempo y fue abortada. Inténtalo de nuevo.']
  } else if (error?.message) {
    messages = [hasHtml(error.message) ? toPlainText(error.message) : error.message]
  }

  if (!messages.length) messages = ['Un error inesperado ocurrió, por favor intente más tarde.']

  messages.forEach((m) => toast.error(m))
}
